var _path, _rect, _rect2, _rect3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnterDesignMode = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "-4 -2 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.5V4C23 2.34315 21.6569 1 20 1H4C2.34315 1 1 2.34315 1 4V20C1 21.6569 2.34315 23 4 23H6.5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 13,
    width: 5,
    height: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 5,
    height: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 5,
    height: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8207 22.9397C15.5386 22.2452 15.0235 21.6703 14.3635 21.3134C13.7036 20.9565 12.9399 20.8398 12.2033 20.9834C11.4667 21.1269 10.803 21.5217 10.3259 22.1002C9.84875 22.6787 9.58789 23.4049 9.58798 24.1543C9.58798 24.4861 9.51974 24.8144 9.3875 25.1187C9.25525 25.4231 9.06182 25.6971 8.81918 25.9237C8.57655 26.1504 8.28988 26.3248 7.97695 26.4363C7.66402 26.5478 7.3315 26.5939 7 26.5718C7.53317 27.4967 8.35721 28.22 9.34419 28.6294C10.3312 29.0387 11.4259 29.1112 12.4584 28.8357C13.4909 28.5601 14.4034 27.9519 15.0542 27.1054C15.7051 26.2589 16.0579 25.2216 16.0579 24.1543C16.0579 23.7247 15.9738 23.3144 15.8207 22.9397ZM15.8207 22.9397C17.1028 22.5035 18.3291 21.918 19.4741 21.1953M14.0361 21.1683C14.473 19.8853 15.0601 18.6582 15.7851 17.5126M19.473 21.1953C21.5179 19.9051 23.2681 18.1998 24.6101 16.1903L28.7897 9.92967C28.9498 9.69123 29.0221 9.40467 28.9941 9.11894C28.9662 8.8332 28.8398 8.56602 28.6365 8.36302C28.4332 8.16001 28.1656 8.03378 27.8795 8.00587C27.5934 7.97796 27.3064 8.05012 27.0676 8.21001L20.7982 12.3848C18.7856 13.7245 17.0775 15.4719 15.7851 17.5137C17.4262 18.2464 18.7392 19.5576 19.473 21.1963",
    strokeWidth: 1.62838,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnterDesignMode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EnterDesignMode.a86b3b2466beb23f3efdd40ded92c97a.svg";